namespace GeniuzPOS.Administration {
    export class PsPosProcessModeColumns {
        static columnsKey = 'Administration.PsPosProcessMode';
    }
}
